export const state = () => ({
  allMentors: [],
})

export const mutations = {
  setMentors(state, mentors) {
    state.allMentors = mentors
  },
  setMentorById(state, { id, mentorData }) {
    const index = state.allMentors.findIndex((mentor) => mentor.id === id)
    if (index !== -1) {
      state.allMentors.splice(index, 1, mentorData)
    } else {
      state.allMentors.push(mentorData)
    }
  },
}

export const getters = {
  getMentors(state) {
    return state.allMentors
  },
  getMentorById: (state) => (id) => {
    return state.allMentors.find((mentor) => mentor.id === id)
  },
}
